import * as supplierActions from '../../actions/supplier.actions';
import { SupplierItemsStateInterface } from './supplier-items-state.interface';


/**
 * items reducer
 *
 * @param state the current state
 * @param action an action that may result in returning a new state
 */
export const items = (state: SupplierItemsStateInterface, action: supplierActions.Actions): SupplierItemsStateInterface => {
  let oldSupplier;
  switch (action.type) {
    case supplierActions.FETCH_SINGLE_SUCCEEDED:
      oldSupplier = state ? state[action.payload.uuid] : null;
      return {
        ...state,
        [action.payload.uuid]: {...oldSupplier, ...action.payload, detailsLoaded: true}
      };
    case supplierActions.FETCH_SINGLE_SUMMARY_SUCCEEDED:
      oldSupplier = state ? state[action.payload.uuid] : null;
      return {
        ...state,
        [action.payload.uuid]: {...oldSupplier, ...action.payload}
      };
    case supplierActions.FETCH_HAS_LEADS_SUCCEEDED:

      oldSupplier = state ? state[action.payload.uuid] : null;
      return {
        ...state,
        [action.payload.uuid]: {...oldSupplier, hasLeads: action.payload.hasLeads}
      };
    case supplierActions.FETCH_MULTI_SUCCEEDED:
      const newSuppliers = Array.isArray(action.payload.items) ? action.payload.items.reduce((prev, curr) =>
        ({...prev, [curr.uuid]: state ? {...state[curr.uuid], ...curr} : curr}), {}) : null;

      return {...state, ...newSuppliers};
    default:
      return state;
  }
};
